import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useWhatsAppNotificationStore = defineStore('whatsapp-notifications', () => {
  const unreadCount = ref(0)
  const isInitialized = ref(false)

  const hasUnreadMessages = computed(() => unreadCount.value > 0)

  const setUnreadCount = (count: number) => {
    unreadCount.value = count
  }

  const resetUnreadCount = () => {
    unreadCount.value = 0
  }

  const setInitialized = (status: boolean) => {
    isInitialized.value = status
  }

  return {
    unreadCount,
    isInitialized,
    hasUnreadMessages,
    setUnreadCount,
    resetUnreadCount,
    setInitialized,
  }
})
